import React, { useEffect, useState } from 'react';
import logo from '../../assets/owlbot_logo_login.png';
import Footer from '../../components/Footer/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';
import { apiUrl } from '../../config/constants';
import { useDispatch } from 'react-redux';
import { updateTokenInfo } from '../../redux/action';
import ActivityIndicator from '../../components/ActivityIndicator/ActivityIndicator';
import FlashBar from '../../components/FlashBar/FlashBar';
import { successMessage } from '../../config/keyword';

const TwoFaAuth = () => {
  const { rememberMe } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    ['e', 'E', '+', '-', '.'].includes(e.key) && e.preventDefault();
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const sanitizedValue = newValue.replace(/[^0-9]/g, '');
    if (e.target.value.length <= 6) {
      setCode(sanitizedValue);
    }
  };
  const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    const obj = {
      rememberClient: true,
      rememberMe: rememberMe === 'true' ? true : false,
      code: code,
    };
    if (code.length === 6) {
      await axios
        .post(`${apiUrl}/auth/2fa/login`, obj, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status === 200) {
            gotResponse(response.data);
          }
        })
        .catch(() => {
          setFlashbar({
            ...flashbar,
            isOpen: true,
            type: flashBarTheme.ERROR,
            message: errorMessage.oops,
          });
          setIsLoading(false);
        });
    }
  };

  const gotResponse = (data: any) => {
    const { isSuccess, requiresTwoFactor, message, token } = data;
    if (isSuccess && !requiresTwoFactor) {
      navigate('/dashboard');
      dispatch(updateTokenInfo(token));
      setIsLoading(false);
    }
    if (!isSuccess && requiresTwoFactor) {
      navigate(`/twofactorAuthorization/${rememberMe}`);
      setIsLoading(false);
      setCode('');
    }
    if (!isSuccess && !requiresTwoFactor) {
      setFlashbar({
        ...flashbar,
        isOpen: true,
        type: flashBarTheme.ERROR,
        message: message,
      });
      setCode('');
      setIsLoading(false);
    }
  };
  const resendCode = async () => {
    setIsLoading(true);
    await axios
      .post(`${apiUrl}/auth/2fa/send-code`)
      .then((response) => {
        if (response.status === 200) {
          setFlashbar({
            ...flashbar,
            isOpen: true,
            type: flashBarTheme.SUCCESS,
            message: successMessage.RESEND_CODE,
          });
          setSeconds(30);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          type: flashBarTheme.ERROR,
          message: errorMessage.oops,
        });
        setIsLoading(false);
      });
  };
  return (
    <div>
      {isLoading ? <ActivityIndicator /> : null}
      <FlashBar
        message={flashbar.message}
        isOpen={flashbar.isOpen}
        type={flashbar.type}
        handleClose={() => {
          setFlashbar({ ...flashbar, isOpen: false });
        }}
      />

      <div className="flex flex-col justify-center items-center h-screen bg-slate-100">
        <div className="border w-96 shadow-lg rounded-sm bg-white">
          <div className="p-8 pb-0">
            <img src={logo} className="w-9/12 mx-auto my-0 pb-5" />
          </div>
          <div className="text-center px-5 py-2 bg-sky-700  text-white mb-4">
            <div className="text-2xl font-normal mb-3">2-Step Verification</div>
            <div>
              Enter the verification code sent to your registered email address
            </div>
          </div>

          <div className="flex flex-col justify-center items-center mb-5">
            <div className="text-blue-700 mb-3">
              <i className="fa-solid fa-envelope-open-text text-[60px]"></i>
            </div>

            <form className="flex gap-2 flex-col" onSubmit={submitHandler}>
              <div className="flex flex-col">
                <input
                  type="number"
                  className={`text-center code-digit border-2 p-1 mr-1`}
                  placeholder="6 digit code"
                  value={code}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => onChangeHandler(e)}
                />
              </div>
              <button
                disabled={code.length === 6 ? false : true}
                type="submit"
                className={`${
                  code.length === 6
                    ? 'bg-blue-500 cursor-pointer'
                    : 'bg-blue-200 cursor-not-allowed'
                } h-8 text-white rounded-sm flex items-center justify-center`}
              >
                Done
              </button>
            </form>
          </div>
          <div className="border-t ">
            <div className="mt-3">
              <div className="p-2 text-sm text-center flex justify-center gap-2 items-center">
                <div
                  className={`${
                    minutes === 0 && seconds === 0
                      ? 'text-blue-400 cursor-pointer'
                      : 'text-blue-200'
                  }  `}
                  onClick={() => resendCode()}
                >
                  Resend access code
                </div>
                {minutes > 0 ||
                  (seconds > 0 && (
                    <p className="text-sm">
                      in {minutes < 10 ? `0${minutes}` : minutes}:
                      {seconds < 10 ? `0${seconds}` : seconds}
                    </p>
                  ))}
              </div>
            </div>
            <div className="mb-3">
              <div
                className="p-2 text-blue-400 text-sm text-center cursor-pointer"
                onClick={() => navigate('/')}
              >
                Back to login page
              </div>
            </div>
          </div>
        </div>
        <div className="absolute right-0 bottom-0">
          {' '}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default TwoFaAuth;
